import { HTTP } from '@/http-common'
import { defaultErrorHandler, getList } from './__common.service'

function getCurrentUser (errorHandler = defaultErrorHandler) {
  return HTTP.get('/users').then((response) => {
    let user = response.data['results'][0]

    return HTTP.get('/users/' + user.id).then((response) => {
      return response
    }, (err) => {
      return errorHandler(err)
    })
  })
}

function getUser (userId, errorHandler = defaultErrorHandler) {
  return HTTP.get('/users/' + userId).then((response) => {
    return response
  }, (err) => {
    return errorHandler(err)
  })
}

function generateToken (errorHandler = defaultErrorHandler) {
  return HTTP.get('/users/current/generate_token').then((response) => {
    return response
  }, (err) => {
    return errorHandler(err)
  })
}

function getInternalUsers (errorHandler = defaultErrorHandler) {
  let filters = {
    internal: 1
  }
  let sort = 'name'
  let type = 'desc'
  let paginate = true

  return getList('/users', sort, type, filters, paginate)
}

function addUser (userData, errorHandler = defaultErrorHandler) {
  let data = JSON.stringify(userData)

  return HTTP.post('/users', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  }).then((response) => {
    return response
  }, (err) => {
    return errorHandler(err)
  })
}

function updateUser (userData, errorHandler = defaultErrorHandler) {
  let data = JSON.stringify(userData)

  return HTTP.put('/users/' + userData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  }).then((response) => {
    return response
  }, (err) => {
    return errorHandler(err)
  })
}

export { getCurrentUser, getInternalUsers, getUser, addUser, updateUser, generateToken }



// WEBPACK FOOTER //
// ./src/services/user.service.js